import { DomainView } from "@/components/domain";
import { Badge } from "@/components/ui/badge";
import { useSheetContext } from "@/context/sheet";
import { useDeleteWorker, useGetWorker } from "@/hooks/workers";
import { T } from "@/i18n";
import { formatPhoneNumber } from "@/lib/utils";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { format } from "date-fns";
import { Key } from "react";

export const Route = createFileRoute("/(workers)/workers/_sheet/$id/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { data, isLoading } = useGetWorker(id);
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutate: deleteWorker } = useDeleteWorker({
    onSuccess: () => {
      close(() => {
        navigate({ to: "/workers" });
      });
    },
  });

  return (
    <DomainView
      domain="workers"
      editLink={(children, key) => (
        <Link to="/workers/$id/edit" params={{ id }} key={key as Key}>
          {children}
        </Link>
      )}
      isLoading={isLoading}
      title={data?.name}
      onDelete={() => deleteWorker(data!)}
      propsList={[
        {
          title: "workers.fields.email",
          value: data?.email ?? "-",
        },
        {
          title: "workers.fields.phone",
          value: formatPhoneNumber(data?.phone),
        },
        {
          title: "workers.fields.birthdate",
          value: data?.birthdate
            ? format(new Date(data.birthdate), "PPP")
            : "-",
        },
        {
          title: "workers.fields.country",
          value: data?.country ? <T tKey={`countries.${data.country}`} /> : "-",
        },
        {
          title: "workers.fields.language",
          value: data?.language?.length ? (
            <div className="flex items-center gap-1">
              {data.language?.map((l) => <Badge key={l}>{l}</Badge>)}
            </div>
          ) : (
            "-"
          ),
        },
      ]}
    />
  );
}
